import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3929138"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-create-queue" }

import { ref } from 'vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmInput,
} from 'tir-components';
import { AdapterService } from './adapter-service';
import { CreateQueueModel, QueueTasksModel } from './models';


export default /*#__PURE__*/_defineComponent({
  __name: 'form-create-queue',
  props: {
  /**ID родительской группы */
  groupId: { type: Number },
  /**ID неймспейса */
  namespaceId: { type: String },
},
  emits: ["onCreate"],
  setup(__props, { emit }) {

const props = __props;





const adapter = new AdapterService();

/**Название очереди */
const queueName = ref('');
/**Сообщение об ошибке */
const errorMessage = ref('');

/**
 * * Валидация формы
 */
const validate = () => {
  if (!props.groupId && !props.namespaceId) return false;

  if (!queueName.value.trim()) {
    errorMessage.value = 'Введите название очереди';
    return false;
  }

  return true;
};

/**
 * * Сброс состояния формы
 */
const resetForm = () => {
  queueName.value = '';
};

const onClick = async () => {
  if (!validate()) return;
  
  const request = new CreateQueueModel({
    Name: queueName.value,
  });
  if (props.groupId) request.GroupId = props.groupId;
  else if (props.namespaceId) request.NamespaceId = props.namespaceId;

  const resp = await adapter.createQueue(request);

  if (!resp.IsSuccess) return;

  const newQueue = new QueueTasksModel({
    Id: resp.Value,
    Name: request.Name,
  });
  if (props.groupId) newQueue.ParentGroupId = request.GroupId;
  else if (props.namespaceId) newQueue.NamespaceId = props.namespaceId;

  resetForm();
  emit('onCreate', newQueue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmInput), {
      modelValue: queueName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queueName).value = $event)),
      label: "Название очереди",
      placeholder: "Новая очередь",
      "is-with-error": !!errorMessage.value,
      "is-show-hint": !!errorMessage.value
    }, {
      hintMessage: _withCtx(() => [
        _createTextVNode(_toDisplayString(errorMessage.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "is-with-error", "is-show-hint"]),
    _createVNode(_unref(TirPmButton), {
      variant: _unref(TirPmButtonVariantEnum).PrimaryState,
      size: _unref(TirPmButtonSizeEnum).Small,
      onClick: onClick
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Сохранить ")
      ]),
      _: 1
    }, 8, ["variant", "size"])
  ]))
}
}

})